import { StoreUtil } from 'doctivity-shared/utils';

export const API_COUNTIES_BY_STATE = 'API_COUNTIES_BY_STATE';
export const API_POSTALCODES_BY_COUNTY = 'API_POSTALCODES_BY_COUNTY';
export const API_COUNTIES_BY_POSTALCODE = 'API_COUNTIES_BY_POSTALCODE';

// redux-saga-requests (0.27) runs GET queries as "take latest" keyed by action
// TYPE, and ignores the takeLatest config override (handleRequests forks the
// watcher saga without its config). Dispatching listCountiesByState for several
// states at once therefore aborts every request but the last, and the aborted
// states never load. Callers must fetch ONE state at a time: dispatch for the
// abbr this returns, then call again whenever the counties store changes until
// it returns null. Failed loads are skipped so a backend error cannot loop.
export const nextStateNeedingCounties = (states, allCounties) => {
  if (!states || states.length === 0) {
    return null;
  }
  const entries = states.map((s) =>
    StoreUtil.get(allCounties, 'counties_by_state', s.abbr));
  if (entries.some((e) => StoreUtil.isLoading(e))) {
    return null; // one request in flight; wait for it
  }
  const i = entries.findIndex(
    (e) => !StoreUtil.isLoaded(e) && !StoreUtil.isLoadFailed(e),
  );
  return i < 0 ? null : states[i].abbr;
};

export const listCountiesByState = (state) => ({
  type: API_COUNTIES_BY_STATE,
  id: state,
  request: {
    url: '/CountiesToPostal',
    method: 'GET',
    params: {
      opts: {
        group: [
          'county_name',
          'geo_id',
        ],
        attributes: [
          'county_name',
          'geo_id',
        ],
        where: { state },
        order: [
          ['county_name', 'ASC'],
        ],
      },
    },
  },
});

export const listPostalcodesByCounty = (county, state) => ({
  type: API_POSTALCODES_BY_COUNTY,
  id: `${county},${state}`,
  request: {
    url: '/CountiesToPostal',
    method: 'GET',
    params: {
      opts: {
        attributes: ['postal_codes'],
        where: {
          state,
          county_name: county,
        },
        order: [
          ['postal_code', 'ASC'],
        ],
      },
    },
  },
});

export const listCountiesByPostalCodes = (postCodes) => ({
  type: API_COUNTIES_BY_POSTALCODE,
  id: postCodes.join(','),
  request: {
    url: '/CountiesToPostal',
    method: 'GET',
    params: {
      opts: {
        attributes: ['city', 'state', 'county_name', 'geo_id', 'postal_code'],
        where: {
          postal_code: postCodes,
        },
        order: [
          ['postal_code', 'ASC'],
        ],
      },
    },
  },
});


